import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { MedicalHistoryEntryCard } from 'components/common/subscriber/imq/health-questionnaire-entry/MedicalHistoryEntryCard';
import { MedicalHistoryAnswer } from 'components/common/subscriber/imq/health-questionnaire-entry/AnswerOption';
import { useImqBrokerHealthQuestionnaireEntryPageStore } from 'store/pages/quote/imq-add-employees/health-questionnaire-entry/pageStore';

export const PageContent: React.FC = observer(() => {
  const {
    getFlowAndPageInitialData,
    isInitialLoading,
    isActionLoading,
    flowDelegate,
    domainParams,
    subscriberHasMedicalConditions,
    setMedicalHistoryAnswer,
    canContinue,
    completeStep,
  } = useImqBrokerHealthQuestionnaireEntryPageStore();

  useEffect(() => {
    void getFlowAndPageInitialData();
  }, []);

  const selectedValue: MedicalHistoryAnswer | '' =
    // eslint-disable-next-line no-nested-ternary
    subscriberHasMedicalConditions === null ? '' : subscriberHasMedicalConditions ? 'yes' : 'no';

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ ...domainParams }}
      pageId={QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_HEALTH_QUESTIONNAIRE_ENTRY}
      isInitialLoading={isInitialLoading}
      isActionLoading={isActionLoading}
      isInfoSectionLoading={flowDelegate.isFlowDataLoading}
      moreInfoBlob={
        flowDelegate.groupInfoDelegate.moreInfoBlobInput
          ? buildGroupContextMoreInfoBlobProps(flowDelegate.groupInfoDelegate.moreInfoBlobInput)
          : undefined
      }
      pageFooter={{
        onComplete: completeStep,
        disableCompleteButton: !canContinue,
        completeButtonText: 'Next',
      }}
    >
      <MedicalHistoryEntryCard selectedValue={selectedValue} onChange={setMedicalHistoryAnswer} />
    </PageInFlowNoSidebarLayout>
  );
});
